import { render } from "./PageNewsList.vue?vue&type=template&id=89f6d532&scoped=true"
import script from "./PageNewsList.vue?vue&type=script&lang=js"
export * from "./PageNewsList.vue?vue&type=script&lang=js"

import "./PageNewsList.vue?vue&type=style&index=0&id=89f6d532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f6d532"]])

export default __exports__